import FormSubmissionsType from '../Models/FormSubmissionsType';
import DataGridRequest from './DataGridRequest';
export class FormSubmissionsRequest extends DataGridRequest<FormSubmissionsType> {
    Url = 'submissions/api';
}
